import { URLS } from 'api/constants';
import { IProvider } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationResponse } from './types';

export async function getProviderById(id?: string) {
  return apiGetSafe<IProvider>(`${URLS.PROVIDER_BY_ID}${id ?? ''}`);
}

export async function listProviders() {
  return apiGet<PaginationResponse<IProvider>>(URLS.PROVIDERS);
}
